import React, { PropTypes, Component } from 'react';
import $ from 'jquery';
import cx from 'classnames';
import { DROPDOWN_SETTINGS } from 'plugins/bootstrap';

class Dropdown extends Component {
  constructor(props) {
    super(props);

    this._setDropdown = this._setDropdown.bind(this);
    this._clearSelection = this._clearSelection.bind(this);
  }

  componentDidMount() {
    this._initDropdown();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.value !== this.props.value) {
      if (!this.props.value) {
        $(this._dropdown).dropdown('clear');
      }

      this._initDropdown();
    } else if (prevProps.items !== this.props.items) {
      if (!this.props.items) {
        $(this._dropdown).dropdown('clear');
      }

      this._initDropdown();
    }
  }

  _setDropdown(ref) {
    this._dropdown = ref;
  }

  _initDropdown() {
    const { options, onChange, onAdd, onRemove } = this.props;

    $(this._dropdown).dropdown({
      ...DROPDOWN_SETTINGS,
      ...options,
      onChange,
      onAdd,
      onRemove,
    });
  }

  _clearSelection(evt) {
    evt.preventDefault();

    const $dropdown = $(this._dropdown);
    $dropdown.dropdown('clear');

    evt.stopPropagation();
  }

  render() {
    const {
      name,
      value,
      disabled,
      selection,
      loading,
      rightDropdown,
      canDelete,
      items,
      renderDefault,
      renderItem,
      className,
      search,
      multiple,
      values,
      renderValue,
      fluid,
    } = this.props;

    const dropdownClassName = cx('ui dropdown', className, {
      selection,
      disabled,
      loading,
      search,
      multiple,
      fluid,
    });

    return (
      <div className={dropdownClassName} ref={this._setDropdown}>
        {name && <input type="hidden" name={name} defaultValue={value} />}
        {!rightDropdown && <i className="dropdown icon" />}
        {multiple && renderValue && values && values.map(renderValue)}
        {canDelete && (
          <i className="remove icon" onClick={this._clearSelection} />
        )}
        {renderDefault()}
        {rightDropdown && <i className="dropdown icon" />}
        <div className="menu">{items.map(renderItem)}</div>
      </div>
    );
  }
}

Dropdown.propTypes = {
  name: PropTypes.string,
  value: PropTypes.any,
  disabled: PropTypes.bool,
  loading: PropTypes.bool,
  rightDropdown: PropTypes.bool,
  selection: PropTypes.bool,
  canDelete: PropTypes.bool,
  items: PropTypes.any.isRequired,
  options: PropTypes.object,
  className: PropTypes.string,
  onChange: PropTypes.func,
  renderDefault: PropTypes.func.isRequired,
  renderItem: PropTypes.func.isRequired,
  multiple: PropTypes.bool,
  search: PropTypes.bool,
  renderValue: PropTypes.func,
  values: PropTypes.array,
  fluid: PropTypes.bool,
  onAdd: PropTypes.func,
  onRemove: PropTypes.func,
};

Dropdown.defaultProps = {
  options: {},
  className: '',
  selection: true,
  disabled: false,
  rightDropdown: false,
  canDelete: false,
  multiple: false,
  search: false,
  fluid: false,
};

export default Dropdown;



// WEBPACK FOOTER //
// ./src/modules/common/components/Dropdown.js